import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { v4 } from 'uuid';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import { Button } from 'components/Buttons';
import TopListItem from './TopListItem';

type Props = {
  questionIndex: number;
}

const TopListItems:FC<Props> = ({ questionIndex }) => {
  const { t } = useTranslation();

  const name = `questions[${questionIndex}].config.items`;

  const { control, formState:{ errors } } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name
  });

  const handleAdd = () => {
    append({ ref: v4(), correctAnswers: [''], scoring: { points: 1000 } });
  }

  const handleDelete = (index:number) => () => {
    remove(index);
  }

  return (
    <div>
      <h2 className="text-white text-xl font-bold leading-6 my-4">{t('labels.items')}</h2>

      {fields.map((item, index) => (
        <TopListItem
          key={item.id}
          name={name}
          index={index}
          onDelete={handleDelete(index)}
          error={errors?.questions?.[questionIndex]?.config?.items?.[index]}
        />
      ))}

      <div className="text-right">
        <Button
          variant="contained"
          onClick={handleAdd}
        >{t('buttons.addItem')}</Button>
      </div>
    </div>
  )
}

export default TopListItems;
